import { useState } from 'react'
import { OrgSiteWlans } from '../../../../types'
import {
  WLANListRow,
  WLANListItemBody,
  WLANListIcon,
  WLANListLeftBlock,
  WLANListRightBlock,
  WLANSeparator,
} from '../styles'
import { mdiWifi } from '@mdi/js'
import theme from 'theme_'
import RadioField from './RadioField'

interface CreateWLANHomeItemProps {
  orgSiteWlan: OrgSiteWlans
  onSelectedTemplate: Function
}

function CreateWLANHomeItem({
  orgSiteWlan,
  onSelectedTemplate,
}: CreateWLANHomeItemProps) {
  const [templateChecked, setTemplateChecked] = useState(false)

  const handleSelectTemplateClick = () => {
    onSelectedTemplate(!templateChecked, orgSiteWlan.id)
    setTemplateChecked(!templateChecked)
  }

  return (
    <div id={orgSiteWlan.name}>
      <WLANSeparator />
      <WLANListRow>
        <WLANListLeftBlock onClick={handleSelectTemplateClick}>
          <RadioField
            value={orgSiteWlan.name}
            inputId={orgSiteWlan.name}
            isChecked={templateChecked}
            name="template_picker"
            onChange={(e: any) => setTemplateChecked(e.target.checked)}
          />
          <WLANListIcon
            path={mdiWifi}
            size={1.5}
            color={theme.colors.otterWarmBlack}
          />
          {orgSiteWlan.name}
        </WLANListLeftBlock>

        <WLANListRightBlock>
          <WLANListItemBody>{orgSiteWlan.wlans.length}</WLANListItemBody>
        </WLANListRightBlock>
      </WLANListRow>
    </div>
  )
}

export default CreateWLANHomeItem
